import { ProductKey } from "@/components/signup/utils";
import { COHORTS, useCohort, useLoggedOut } from "@/components/user-context";
import { useLocation } from "@/utils/location-provider";

import { CrossflowEligibleUser } from "./crossflow-eligible-user";
import { CurrentProductUser } from "./current-product-user";
import { ExistingUser } from "./existing-user";
import { LoggedOut } from "./logged-out";
import { LoggedOutRovo } from "./logged-out-rovo";
import { NewUser } from "./new-user";
import { UpliftEligibleUser } from "./uplift-eligible-user";

export const TeamworkCollectionSignup = () => {
    const cohort = useCohort();
    const loggedOut = useLoggedOut();
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const primaryCollectionProduct = params.get("primaryCollectionProduct");

    if (loggedOut) {
        if (primaryCollectionProduct === ProductKey.ROVO) {
            return <LoggedOutRovo />;
        }
        return <LoggedOut />;
    }

    if (!cohort) {
        return null;
    }

    switch (cohort) {
        case COHORTS.MANAGED_USER:
        case COHORTS.WEEK_ONE_USER:
        case COHORTS.CURRENT_PRODUCT_USER:
            return <CurrentProductUser />;

        case COHORTS.CROSSFLOW_ELIGIBLE_USER:
            return <CrossflowEligibleUser />;

        case COHORTS.UPLIFT_ELIGIBLE_USER:
            return <UpliftEligibleUser />;

        case COHORTS.NEW_USER:
            return <NewUser />;
        default:
            return <ExistingUser />;
    }
};
